/* !!! NEVER CHANGE VALUES OF THESE CONSTANTS FOR ALLPWD PROJECT !!! */
/* !!! IT IS IN PRODUCITON !!! */
export const SALT = '$2a$10$6Oa2szCjipKWS68P3x1bHu';
export const DS = '$2a$10$YtkT46hkvp.fmf.jdJvotu';
export const CSALT = new Uint8Array([0x33, 0x1A, 0xD5, 0x06, 0xB3, 0x75, 0x69, 0x55, 0x57, 0xF2]);